import {useMutation, UseMutationOptions, useQueryClient,} from '@tanstack/react-query';
import {Campaign, CreateCampaign} from '@tinct/core-api-models';
import {ApiError, tinctApi} from '../../api';

export const createCampaign = async (data: CreateCampaign): Promise<Campaign> => {
  return await tinctApi.campaigns.createCampaign(data);
};

export const useCreateCampaign = (
  options?: Omit<
    UseMutationOptions<Campaign, ApiError, CreateCampaign>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createCampaign,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
      if(args[0].organization) {
        queryClient.invalidateQueries({ queryKey: ['organization', args[0].organization.id] });
      }
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
